// extracted by mini-css-extract-plugin
export default {"row":"CategoryPicker_row__BBK-5","label":"CategoryPicker_label__I2TKH","trigger":"CategoryPicker_trigger__+2ViJ"};